import luPreview from "./preview";
luPreview.install = function(Vue) {
  Vue.component(luPreview.name, luPreview);
};

export default luPreview;
